import React from 'react';

import { Artist } from 'app/shared/typings';
import {
  Box,
  Grid,
  GridItem,
  Image,
  NavigationLink,
} from 'app/shared/components/atoms';
import { ArtistSocialIcons } from 'app/fan/components/molecules';
import { FollowArtistButton } from 'app/fan/components/organisms';

import ArtistDescription from './ArtistDescription';

const DEFAULT_ARTIST_IMAGE_ASSET_PATH =
  '/assets/event/post-event-placeholder-540-380-b0c62f5dbef45488f3b553772a655233aede46f452358830206cbff9e7cb8878.jpg';

export const Artists = ({ artists }: { artists?: Artist[] }) => {
  if (!artists) {
    return null;
  }

  return (
    <Box>
      {artists.map((artist) => {
        return (
          <Box data-qaid="artist-card" key={artist.id} mb={16}>
            <Grid
              mobileNumberOfColumns={1}
              tabletNumberOfColumns={1}
              smallDesktopNumberOfColumns={3}
              gap={5}
              rowGap={8}
            >
              <GridItem
                mobileStart={1}
                tabletStart={1}
                smallDesktopStart={1}
                largeDesktopStart={1}
                mobile={1}
                tablet={1}
                smallDesktop={1}
                largeDesktop={1}
              >
                {artist.imageThumb && (
                  <Image
                    src={artist.imageThumb || DEFAULT_ARTIST_IMAGE_ASSET_PATH}
                    aspectRatio="540/380"
                    h="inherit"
                  />
                )}
              </GridItem>
              <GridItem
                mobileStart={1}
                tabletStart={1}
                smallDesktopStart={2}
                largeDesktopStart={2}
                mobile={1}
                tablet={1}
                smallDesktop={2}
                largeDesktop={2}
                flexDirection="column"
                gap={8}
              >
                <NavigationLink
                  variant="tertiary"
                  fontSize="fontSize500"
                  fontFamily="title"
                  textDecoration="underline"
                  href={`/artists/${artist.cachedSlug}`}
                >
                  {artist.title}
                </NavigationLink>
                <FollowArtistButton artistId={artist.id} />
                <Box w="100%">
                  {artist.description && (
                    <ArtistDescription
                      text={artist.description}
                      artistId={artist.id}
                    />
                  )}
                </Box>
                {artist.socialUrls && (
                  <ArtistSocialIcons
                    data-qaid="artist-socials"
                    socialUrls={artist.socialUrls}
                  />
                )}
              </GridItem>
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};
